// src/app/blog/shared/blog-entry-base.ts
import { AfterViewInit, ElementRef, OnDestroy, ViewChild, Input, Directive } from '@angular/core';
import { TranslationSyncService } from '../../../services/translation-sync.service';

/**
 * Basis-Logik für Blog-Entry-Komponenten mit data-translate.
 * - Registriert alle [data-translate] ab #entryRoot nach Render.
 * - Optional: weitere Roots via addExtraRoot() registrierbar (z. B. modale Bereiche).
 */
@Directive() // keine eigene View, nur Logik zum Erben
export abstract class BlogEntryBase implements AfterViewInit, OnDestroy {
  @Input() darkMode = false;

  @ViewChild('entryRoot', { static: true })
  entryRoot!: ElementRef<HTMLElement>;

  // Optional zusätzliche Wurzeln (z. B. dynamisch dazugefügte Container)
  private extraRoots: Set<HTMLElement> = new Set();

  protected constructor(protected sync: TranslationSyncService) {}

  ngAfterViewInit(): void {
    if (this.entryRoot?.nativeElement) {
      this.registerAll(this.entryRoot.nativeElement);
    }
    for (const root of this.extraRoots) {
      this.registerAll(root);
    }
  }

  ngOnDestroy(): void {
    // Wenn dein Service ein unregister unterstützt:
    if ((this.sync as any).unregister) {
      const unregister = (this.sync as any).unregister.bind(this.sync);
      const unregisterAll = (root: HTMLElement) =>
        root.querySelectorAll<HTMLElement>('[data-translate]').forEach(el => unregister(el));
      if (this.entryRoot?.nativeElement) unregisterAll(this.entryRoot.nativeElement);
      for (const root of this.extraRoots) unregisterAll(root);
    }
  }

  /** Für Sonderfälle: weitere Root-Knoten anmelden (z. B. Overlay, Portal, o. ä.). */
  protected addExtraRoot(root: HTMLElement | null | undefined): void {
    if (root) this.extraRoots.add(root);
  }

  /** Kernlogik: alle [data-translate] registrieren. */
  protected registerAll(root: HTMLElement): void {
    root.querySelectorAll<HTMLElement>('[data-translate]').forEach(el => {
      const key = el.getAttribute('data-translate');
      if (key) this.sync.register(el, key);
    });
  }
}
